import React, { Component } from 'react';
import styled from 'styled-components';

import PageWrapper from './ui/PageWrapper';
import PiecesList from './PiecesList';

const H2 = styled.h2`
  color: white;
  text-transform: uppercase;
  font-family: Capricorn, sans-serif;
  font-weight: normal;
`;

class Category extends Component {  render() {
    const { category, config } = this.props;

    const pieces = config.pieces.filter(piece => piece.categories.indexOf(category) !== -1)
    return (
      <PageWrapper>
        <H2>{ category.replace(/-/g, " ")}</H2>
        <PiecesList pieces={pieces} />
      </PageWrapper>
    );
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/Category.js